import { FIELD_CONSTRAINTS, LOGIC_GATE } from '../../../utility/constants'

export const constraintValidationWithOperation = (
  fieldsProcessDataValue,
  fieldsConditionalValue,
  operation,
) => {
  switch (operation) {
    case FIELD_CONSTRAINTS.EQUAL:
    case 'equal':
      return fieldsProcessDataValue == fieldsConditionalValue

    case FIELD_CONSTRAINTS.GT:
      return Number(fieldsProcessDataValue) > Number(fieldsConditionalValue)

    case FIELD_CONSTRAINTS.GTE:
      return Number(fieldsProcessDataValue) >= Number(fieldsConditionalValue)

    case FIELD_CONSTRAINTS.LT:
      return Number(fieldsProcessDataValue) < Number(fieldsConditionalValue)

    case FIELD_CONSTRAINTS.LTE:
      return Number(fieldsProcessDataValue) <= Number(fieldsConditionalValue)

    case FIELD_CONSTRAINTS.INT: {
      const num = Number(fieldsProcessDataValue)

      return (
        fieldsProcessDataValue !== '' &&
        fieldsProcessDataValue !== null &&
        fieldsProcessDataValue !== undefined &&
        Number.isInteger(num)
      )
    }

    case FIELD_CONSTRAINTS.POSITIVE_INT: {
      const num = Number(fieldsProcessDataValue)

      return (
        fieldsProcessDataValue !== '' &&
        fieldsProcessDataValue !== null &&
        fieldsProcessDataValue !== undefined &&
        Number.isInteger(num) &&
        num > 0
      )
    }

    case FIELD_CONSTRAINTS.WHOLE_NUM: {
      const num = Number(fieldsProcessDataValue)

      return (
        fieldsProcessDataValue !== '' &&
        fieldsProcessDataValue !== null &&
        fieldsProcessDataValue !== undefined &&
        !Number.isNaN(num) &&
        num >= 0
      )
    }

    case FIELD_CONSTRAINTS.POSITIVE: {
      const num = Number(fieldsProcessDataValue)

      return (
        fieldsProcessDataValue !== '' &&
        fieldsProcessDataValue !== null &&
        fieldsProcessDataValue !== undefined &&
        !Number.isNaN(num) &&
        num > 0
      )
    }

    default:
      return false
  }
}

export const applyLogicGate = (values, gateName) => {
  if (values.length === 0) {
    return false
  }

  switch (gateName) {
    case LOGIC_GATE.AND:
      return values.every((value) => value === true) // AND gate: all values must be true
    case LOGIC_GATE.OR:
      return values.some((value) => value === true) // OR gate: any value being true returns true
    case LOGIC_GATE.NOR:
      return !values.some((value) => value === true) // NOR gate: returns true only if all values are false
    default:
      throw new Error('Invalid gate name. Valid gates are AND, OR, and NOR.')
  }
}
